import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class JobService {
  constructor(private coreService: CoreService) { }

  list(): Observable<any> {
    debugger
    return this.coreService.get(
      ServiceRoute.job.list,
      new CommonHttpOption().headers
    );
  }
}
